import { useState, useEffect } from 'react';

export interface Link {
  url: string | null;
  target: string;
}

const useLinks = (url: string | null) => {
  const [link, setLink] = useState<Link>();
  const ORIGIN_EXPRESSION = /^https?:\/\/[^/?#]+/i;

  useEffect(() => {
    if (url) {
      if (isExternal(url)) {
        setLink({ url: url, target: '_blank' });
      } else {
        setLink({ url: url, target: '_self' });
      }
    }
  }, [url]);

  const compareStrings = (a: string, b: string) => a.toLowerCase() === b.toLowerCase();

  const isExternal = (url: string, origin = location.origin) => {
    if (url == null) {
      return false;
    }
    if (url === '') {
      return false;
    }
    const match = url.match(ORIGIN_EXPRESSION);
    if (match) {
      return !compareStrings(origin, match[0]); // web page origin !== indicated url origin
    }
    return false;
  };

  return { url: link?.url, target: link?.target };
};

export default useLinks;
